// SvgIcon Component

import React from 'react'
import PropTypes from 'prop-types'

const SvgIcon = ({ name, size, className }) => (
  <svg
    fill='currentColor'
    viewBox='0 0 100 100'
    style={{ width: `${size}px`, height: `${size}px` }}
    className={`svgicon ${className}`}
  >
    <use
      xlinkHref={`/svgicons/defs/svg/sprite.def.svg?v=1.0.116#icon-${name}`}
    />
  </svg>
)

SvgIcon.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string
}

SvgIcon.defaultProps = {
  name: '',
  className: '',
  size: '16'
}

export default SvgIcon
